import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { makeGetCurrentTeam } from '../selectors/teams';
import { makeGetSubscriptionIsExpired } from '../selectors/billing';
import { makeGetCurrentUser } from '../selectors/users';

import { DocumentFocusProvider } from 'context/DocumentFocusContext';
import { LocaleProvider } from 'context/LocaleContext';
import { BrowserNotificationsProvider } from 'context/BrowserNotificationsContext';
import { NetworkConnectionProvider } from 'context/NetworkConnectionContext';
import { AlertProvider } from 'context/AlertContext';
import { UserStorageProvider } from 'context/UserStorageContext';

import AppHead from './app-head';

class AppWrap extends PureComponent {
    isOnNonSubscriptionAllowed(loc) {
        return Boolean(loc.pathname === '/upgrade' || loc.pathname === '/dashboard' || loc.pathname === '/' || loc.pathname.match(/^\/settings\/(team|profile|notifications|apps)/));
    }

    toggleBlock() {
        if (this.unblock) {
            this.unblock();
        }

        if (this.props.isExpired) {
            if (!this.isOnNonSubscriptionAllowed(this.props.history.location)) {
                this.props.history.push({
                    pathname: '/dashboard'
                });
            }

            this.unblock = this.props.history.block(locaction => {
                return this.isOnNonSubscriptionAllowed(locaction);
            });
        } else {
            this.unblock && this.unblock();
        }
    }

    componentDidMount() {
        this.toggleBlock();
    }

    componentDidUpdate(prevProps) {
        if (this.props.isExpired !== prevProps.isExpired) {
            this.toggleBlock();
        }
    }

    render() {
        const { localeDateFormat, localeTimeFormat, localeWeekStart, localeLanguage, history, children } = this.props;
        return (
            <DocumentFocusProvider>
                <NetworkConnectionProvider>
                    <AlertProvider>
                        <BrowserNotificationsProvider>
                            <UserStorageProvider>
                                <LocaleProvider
                                    dateFormat={localeDateFormat}
                                    timeFormat={localeTimeFormat}
                                    weekStart={localeWeekStart}
                                    language={localeLanguage}
                                >
                                    <AppHead history={history} />

                                    <div className="app-wrap-inner">
                                        <div className="app">{ children }</div>
                                    </div>
                                </LocaleProvider>
                            </UserStorageProvider>
                        </BrowserNotificationsProvider>
                    </AlertProvider>
                </NetworkConnectionProvider>
            </DocumentFocusProvider>
        );
    }
}

const makeMapStateToProps = () => {
    const getCurrentTeam = makeGetCurrentTeam();
    const getCurrentUser = makeGetCurrentUser();
    const getSubscriptionIsExpired = makeGetSubscriptionIsExpired();

    return ({ teams, users }) => {
        const currentTeam = teams && getCurrentTeam(teams);
        const currentUser = getCurrentUser(users);

        return {
            isExpired: currentTeam && getSubscriptionIsExpired(currentTeam),
            localeDateFormat: currentUser?.date_format,
            localeTimeFormat: currentUser?.time_format,
            localeWeekStart: currentUser?.week_start,
            localeLanguage: currentUser?.language
        }
    };
};

export default connect(makeMapStateToProps)(AppWrap);

